module.exports = __webpack_public_path__ + "static/media/loadingLogo.169ff205.png";